import { jsx as u } from "react/jsx-runtime";
import { InputGroup as U, Intent as R, Icon as C, TextArea as z } from "@blueprintjs/core";
import { IconNames as T } from "@blueprintjs/icons";
import { TagWithDropdown as L } from "@strata/react-tags";
import { Field as D, useFormikContext as O, getIn as j } from "formik";
import { useMemo as w, useState as H, useEffect as K } from "react";
import * as W from "yup";
import { getValidationMessage as _, conditionalString as P, PHONE_NUMBER_REGEX as X } from "@strata/helper-functions";
import { FormFieldWrapper as G } from "@strata/react-form-field-wrapper";
import "./main.scss";
const k = ({
  id: t,
  name: a,
  disabled: e = !1,
  leftIcon: o,
  leftElement: h,
  inline: g = !1,
  fill: p,
  helperText: d,
  label: m = "",
  rightElement: l,
  placeholderText: s = "",
  required: r = !1,
  requiredValidationMessage: i,
  verticalSpacingSmall: c = !1,
  type: n = "text",
  step: v,
  min: f,
  onChange: x,
  onBlur: b,
  onKeyDown: I,
  value: M = "",
  autoFocus: F = !1,
  tabIndex: N,
  inputRef: $
}) => /* @__PURE__ */ u(
  G,
  {
    label: m,
    labelFor: t,
    disabled: e,
    helperText: d,
    inline: g,
    fill: p,
    required: r,
    requiredValidationMessage: i,
    verticalSpacingSmall: c,
    inputContent: /* @__PURE__ */ u(
      U,
      {
        className: "sds_input-group",
        id: t,
        name: a,
        disabled: e,
        leftIcon: o,
        leftElement: h,
        fill: !0,
        placeholder: s,
        rightElement: l,
        intent: i ? R.DANGER : void 0,
        type: n,
        step: v,
        min: f,
        onChange: x,
        onBlur: b,
        onKeyDown: I,
        value: M,
        autoFocus: F,
        tabIndex: N,
        inputRef: $
      }
    )
  }
), V = ({
  id: t,
  name: a,
  disabled: e = !1,
  leftIcon: o,
  leftElement: h,
  inline: g = !1,
  fill: p,
  helperText: d,
  label: m = "",
  rightElement: l,
  placeholderText: s = "",
  required: r = !1,
  requiredValidationMessage: i,
  verticalSpacingSmall: c = !1,
  step: n = "any",
  min: v,
  onChange: f,
  onBlur: x,
  value: b = void 0,
  autoFocus: I = !1,
  tabIndex: M,
  inputRef: F,
  maxDecimalPlaces: N = void 0
}) => /* @__PURE__ */ u(
  k,
  {
    disabled: e,
    label: m,
    helperText: d,
    inline: g,
    fill: p,
    required: r,
    requiredValidationMessage: i,
    verticalSpacingSmall: c,
    leftIcon: o,
    leftElement: h,
    placeholderText: s,
    rightElement: l,
    type: "number",
    name: a,
    id: t,
    step: n,
    min: v,
    onKeyDown: ($) => {
      N != null && N <= 0 && $.key === "." && $.preventDefault();
    },
    onChange: ($) => {
      var y;
      const [B, E] = ((y = $.target.value) == null ? void 0 : y.split(".")) ?? [];
      if (N != null && (E == null ? void 0 : E.length) > 0) {
        const A = E.substring(0, N), q = A && `.${A}`;
        $.target.value = `${B}${q}`;
      }
      f == null || f($);
    },
    onBlur: x,
    value: b,
    autoFocus: I,
    tabIndex: M,
    inputRef: F
  }
), Y = ({
  id: t,
  disabled: a,
  leftIcon: e,
  leftElement: o,
  inline: h,
  fill: g,
  helperText: p,
  label: d,
  rightElement: m,
  placeholderText: l,
  required: s,
  requiredValidationMessage: r,
  verticalSpacingSmall: i,
  step: c,
  min: n,
  onChange: v,
  onBlur: f,
  value: x,
  autoFocus: b,
  tabIndex: I,
  inputRef: M,
  maxDecimalPlaces: F,
  validate: N = void 0
}) => /* @__PURE__ */ u(D, { name: t, validate: N, children: ({ field: $, form: B }) => /* @__PURE__ */ u(
  V,
  {
    id: $.name,
    name: $.name,
    onChange: v ?? B.handleChange,
    onBlur: f ?? B.handleBlur,
    value: x ?? $.value,
    disabled: a,
    label: d,
    helperText: p,
    inline: h,
    fill: g,
    required: s,
    requiredValidationMessage: r ?? _($.name, B),
    verticalSpacingSmall: i,
    leftIcon: e,
    leftElement: o,
    placeholderText: l,
    rightElement: m,
    step: c,
    min: n,
    maxDecimalPlaces: F,
    autoFocus: b,
    tabIndex: I,
    inputRef: M
  }
) }), J = (t) => (t ?? 0) > 0, Q = ({
  id: t,
  label: a,
  minAllowedBid: e = void 0,
  referentPriceType: o = "--",
  disabled: h = !1,
  required: g = !0,
  verticalSpacingSmall: p = !0,
  helperText: d
}) => {
  const m = O(), l = j(m.values, t), s = w(
    () => [
      // Only show plus sign if no minAllowedBid or minAllowedBid or bidAmount is greater than 0
      ...e == null || Math.max(e, l ?? 0) > 0 ? [
        {
          text: o,
          labelElement: /* @__PURE__ */ u(
            C,
            {
              icon: T.PLUS,
              size: 14,
              style: { minWidth: 14, marginRight: 4 },
              className: "margin__bottom--xx-small"
            }
          ),
          value: 1
        }
      ] : [],
      {
        text: `${o} `,
        labelElement: /* @__PURE__ */ u(C, { icon: T.MINUS, size: 14, className: "margin__bottom--xx-small" }),
        value: -1
      }
    ],
    [e, l, o]
  ), [r, i] = H(s[0]);
  K(() => {
    l ? i(
      s.find((n) => n.value === (J(l) ? 1 : -1)) ?? s[0]
    ) : r != null && r.text && !r.text.includes(o) && i(s[0]);
  }, [l, s, o, r.text]);
  const c = (n, v) => {
    (async () => await m.setFieldValue(
      t,
      n && Number(n) * v
    ))();
  };
  return /* @__PURE__ */ u(
    Y,
    {
      label: a,
      id: t,
      maxDecimalPlaces: 2,
      disabled: h,
      step: "0.01",
      min: 0,
      required: g,
      verticalSpacingSmall: p,
      helperText: d,
      value: l && Math.abs(l),
      onChange: (n) => c(n.target.value, r.value),
      leftElement: /* @__PURE__ */ u("div", { style: { marginLeft: -10 }, children: /* @__PURE__ */ u(
        L,
        {
          disabled: h,
          selectedItem: r,
          menuItemArray: s,
          onItemSelect: (n) => {
            l ? c(Math.abs(l), n.value) : i(n);
          }
        }
      ) })
    }
  );
};
Q.validator = () => W.number().moreThan(-100, "Must be below 100%").lessThan(100, "Must be below 100%");
const Z = ({
  id: t,
  name: a,
  disabled: e,
  inline: o,
  fill: h,
  helperText: g,
  label: p,
  rightElement: d,
  required: m,
  requiredValidationMessage: l,
  verticalSpacingSmall: s,
  onChange: r,
  onBlur: i,
  value: c,
  autoFocus: n,
  tabIndex: v,
  inputRef: f,
  showCents: x = !0
}) => /* @__PURE__ */ u(
  V,
  {
    disabled: e,
    label: p,
    helperText: g,
    inline: o,
    fill: h,
    required: m,
    placeholderText: x ? "0.00" : "0",
    requiredValidationMessage: l,
    verticalSpacingSmall: s,
    leftElement: /* @__PURE__ */ u("div", { className: "padding__right--xx-small", children: "$" }),
    rightElement: d,
    name: a,
    id: t,
    step: x ? 0.01 : 1,
    maxDecimalPlaces: x ? 2 : 0,
    onChange: r,
    onBlur: i,
    value: c,
    autoFocus: n,
    tabIndex: v,
    inputRef: f
  }
), ce = ({
  id: t,
  disabled: a,
  inline: e,
  fill: o,
  helperText: h,
  label: g,
  rightElement: p,
  required: d,
  requiredValidationMessage: m,
  verticalSpacingSmall: l,
  onChange: s,
  onBlur: r,
  value: i,
  autoFocus: c,
  tabIndex: n,
  inputRef: v,
  showCents: f,
  validate: x = void 0
}) => /* @__PURE__ */ u(D, { name: t, validate: x, children: ({ field: b, form: I }) => /* @__PURE__ */ u(
  Z,
  {
    showCents: f,
    disabled: a,
    label: g,
    helperText: h,
    inline: e,
    fill: o,
    required: d,
    requiredValidationMessage: m ?? _(b.name, I),
    verticalSpacingSmall: l,
    rightElement: p,
    name: b.name,
    id: b.name,
    onChange: s ?? I.handleChange,
    onBlur: r ?? I.handleBlur,
    value: i ?? b.value,
    autoFocus: c,
    tabIndex: n,
    inputRef: v
  }
) });
function ee(t) {
  let a = "";
  if (!t)
    return a;
  let e = 0;
  return t.startsWith("1") && (a = t.substring(e, e + 1), e += 1), t.length > e && (a = `${P(!!a, `${a} `)}(${t.substring(
    e,
    e + 3
  )}`, e += 3), t.length > e && (a = `${a}) ${t.substring(e, e + 3)}`, e += 3), t.length > e && (a = `${a}-${t.substring(e, e + 4)}`, e += 4), t.length > e && (a = `${a} ext. ${t.substring(e, e + 6)}`), a;
}
const S = ({
  id: t,
  name: a,
  disabled: e = !1,
  leftIcon: o,
  inline: h = !1,
  fill: g,
  helperText: p,
  label: d = "",
  rightElement: m,
  placeholderText: l = "",
  required: s = !1,
  requiredValidationMessage: r,
  verticalSpacingSmall: i = !1,
  step: c,
  onChange: n,
  onBlur: v,
  value: f = "",
  autoFocus: x = !1,
  tabIndex: b,
  inputRef: I,
  allowExtension: M = !1
}) => /* @__PURE__ */ u(
  k,
  {
    disabled: e,
    label: d,
    helperText: p,
    inline: h,
    fill: g,
    required: s,
    requiredValidationMessage: r,
    verticalSpacingSmall: i,
    leftIcon: o,
    placeholderText: l,
    rightElement: m,
    type: "tel",
    name: a,
    id: t,
    step: c,
    onChange: (F) => {
      const N = F.target.value.replace(/\D/g, "");
      let $ = 10;
      N != null && N.startsWith("1") && ($ += 1), M && ($ += 6), F.target.value = N.substring(0, $), n == null || n(F);
    },
    onBlur: v,
    value: ee(f),
    autoFocus: x,
    tabIndex: b,
    inputRef: I
  }
);
S.validator = () => W.string().matches(X, "Invalid phone number.");
const te = ({
  id: t,
  disabled: a,
  leftIcon: e,
  inline: o,
  fill: h,
  helperText: g,
  label: p,
  rightElement: d,
  placeholderText: m,
  required: l,
  requiredValidationMessage: s,
  verticalSpacingSmall: r,
  step: i,
  onChange: c,
  onBlur: n,
  value: v,
  autoFocus: f,
  tabIndex: x,
  inputRef: b,
  allowExtension: I,
  validate: M = void 0
}) => /* @__PURE__ */ u(D, { name: t, validate: M, children: ({ field: F, form: N }) => /* @__PURE__ */ u(
  S,
  {
    allowExtension: I,
    disabled: a,
    label: p,
    helperText: g,
    inline: o,
    fill: h,
    required: l,
    requiredValidationMessage: s ?? _(F.name, N),
    verticalSpacingSmall: r,
    leftIcon: e,
    placeholderText: m,
    rightElement: d,
    name: F.name,
    id: F.name,
    step: i,
    onChange: c ?? N.handleChange,
    onBlur: n ?? N.handleBlur,
    value: v ?? F.value,
    autoFocus: f,
    tabIndex: x,
    inputRef: b
  }
) });
te.validator = S.validator;
const ae = ({
  id: t,
  name: a,
  helperText: e,
  inline: o = !1,
  label: h = "",
  fill: g,
  required: p = !1,
  placeholderText: d = "",
  requiredValidationMessage: m,
  verticalSpacingSmall: l = !1,
  disabled: s = !1,
  onChange: r,
  onBlur: i,
  value: c = "",
  autoFocus: n = !1,
  tabIndex: v,
  inputRef: f,
  autoResize: x = !0
}) => /* @__PURE__ */ u(
  G,
  {
    label: h,
    labelFor: t,
    disabled: s,
    helperText: e,
    inline: o,
    fill: g,
    required: p,
    requiredValidationMessage: m,
    verticalSpacingSmall: l,
    inputContent: /* @__PURE__ */ u(
      z,
      {
        className: "sds_text-area",
        id: t,
        name: a,
        autoResize: x,
        fill: !0,
        placeholder: d,
        disabled: s,
        intent: m ? R.DANGER : void 0,
        onChange: r,
        onBlur: i,
        value: c,
        autoFocus: n,
        tabIndex: v,
        inputRef: f
      }
    )
  }
), ge = ({
  id: t,
  helperText: a,
  inline: e,
  label: o,
  fill: h,
  required: g,
  placeholderText: p,
  requiredValidationMessage: d,
  verticalSpacingSmall: m,
  disabled: l,
  onChange: s,
  onBlur: r,
  value: i,
  autoFocus: c,
  tabIndex: n,
  inputRef: v,
  autoResize: f,
  validate: x = void 0
}) => /* @__PURE__ */ u(D, { name: t, validate: x, children: ({ field: b, form: I }) => /* @__PURE__ */ u(
  ae,
  {
    id: b.name,
    name: b.name,
    disabled: l,
    label: o,
    helperText: a,
    inline: e,
    required: g,
    requiredValidationMessage: d ?? _(b.name, I),
    verticalSpacingSmall: m,
    fill: h,
    placeholderText: p,
    onChange: s ?? I.handleChange,
    onBlur: r ?? I.handleBlur,
    value: i ?? b.value,
    autoFocus: c,
    tabIndex: n,
    inputRef: v,
    autoResize: f
  }
) }), pe = ({
  id: t,
  disabled: a,
  leftIcon: e,
  leftElement: o,
  inline: h,
  fill: g,
  helperText: p,
  label: d,
  rightElement: m,
  placeholderText: l,
  required: s,
  requiredValidationMessage: r,
  verticalSpacingSmall: i,
  type: c,
  step: n,
  min: v,
  onChange: f,
  onBlur: x,
  onKeyDown: b,
  value: I,
  autoFocus: M,
  tabIndex: F,
  inputRef: N,
  validate: $ = void 0
}) => /* @__PURE__ */ u(D, { name: t, validate: $, children: ({ field: B, form: E }) => /* @__PURE__ */ u(
  k,
  {
    id: B.name,
    name: B.name,
    disabled: a,
    label: d,
    helperText: p,
    inline: h,
    fill: g,
    required: s,
    requiredValidationMessage: r ?? _(B.name, E),
    verticalSpacingSmall: i,
    leftIcon: e,
    leftElement: o,
    placeholderText: l,
    rightElement: m,
    type: c,
    step: n,
    min: v,
    value: I ?? B.value,
    onChange: f ?? E.handleChange,
    onBlur: x ?? E.handleBlur,
    onKeyDown: b,
    autoFocus: M,
    tabIndex: F,
    inputRef: N
  }
) });
export {
  Q as BidInput,
  Z as DollarInput,
  ce as DollarInputFormik,
  V as NumberInput,
  Y as NumberInputFormik,
  S as PhoneInput,
  te as PhoneInputFormik,
  ae as TextArea,
  ge as TextAreaFormik,
  k as TextInput,
  pe as TextInputFormik
};
//# sourceMappingURL=index.js.map
